import { calculateAdvanceAmountPercent } from 'app/pages/loanApplication/tabs/loanClosingCDS/shared/FundingInformation/FundingInformation.utils';

import { WireToInformationFieldId } from '../../Content.constants';

export const getAdvanceAmountPercentUpdate = ({ name, value, formRef }) => {
  const fields = {
    [WireToInformationFieldId.WIRE_AMOUNT]: formRef.current[WireToInformationFieldId.WIRE_AMOUNT],
    [WireToInformationFieldId.ADVANCE_AMOUNT]:
      formRef.current[WireToInformationFieldId.ADVANCE_AMOUNT],
    [WireToInformationFieldId.ADD_ADVANCE_AMOUNT]:
      formRef.current[WireToInformationFieldId.ADD_ADVANCE_AMOUNT],
    [name]: value,
  };

  const percent = calculateAdvanceAmountPercent({
    advanceAmount: fields[WireToInformationFieldId.ADVANCE_AMOUNT],
    addAdvanceAmount: fields[WireToInformationFieldId.ADD_ADVANCE_AMOUNT],
    wireAmount: fields[WireToInformationFieldId.WIRE_AMOUNT],
  });

  return { [name]: value, [WireToInformationFieldId.ADVANCE_AMOUNT_PERCENT]: percent };
};
